module.exports = __webpack_public_path__ + "static/media/post-as-guest.041eedc9.gif";